import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import SarasTooltip from '../../notifications/SarasTooltip';

const useStyles = makeStyles((theme) => ({
  chip: {
    margin: theme.spacing(0.5),
    flex: '0 0 auto', // Prevent chips from shrinking
  },
}));

const SarasChip = ({data, className, onClick, onDelete, icon}) => {
  const classes = useStyles();

  const handleClick = (chipClicked) => (event) => {
    if(onClick) onClick(event.currentTarget, chipClicked.key);
  };

  const handleDelete = (chipToDelete) => (event) => {
    if(onDelete) onDelete(chipToDelete.key);
  };

  return (
    <SarasTooltip title={data.val} >
      <Chip
          size="small"
          label={data.val}
          icon={icon}
          onDelete={onDelete ? handleDelete(data) : undefined}
          onClick={onClick ? handleClick(data) : undefined}
          className={className || classes.chip}
      />
    </SarasTooltip>
  );
}

export default SarasChip;
